import { useMutation, useQueryClient } from '@tanstack/react-query';

import { resetRezeptPrintInvoice } from '@/services/main/rezept';
import { useClinicContext } from './useClinicContext';

/**
 * Mutation hook — reset print_invoice = -1 for a single rezept (item 3.7 BD spec).
 * On success, invalidates the invoice list query so the table reflects the change
 * without requiring a manual 検索.
 */
export const useResetRezeptPrintInvoice = () => {
  const { tenant, clinicNumber } = useClinicContext();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (rezeptId: number) =>
      resetRezeptPrintInvoice(tenant ?? '', clinicNumber ?? '', rezeptId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['rezept-invoice', 'list'] });
    },
  });
};

export default useResetRezeptPrintInvoice;
